import MeetupItem from "./MeetupItem";
import classes from "./MeetupList.module.css";

function MeetupList(props) {
    return (
        <ul className={classes.list}>
            {props.meetups.map((meetup, index) => {
                return (
                <MeetupItem
                    key={index}
                    id={meetup.id}
                    image={meetup.image}
                    address={meetup.address}
                    description={meetup.description}
                    title={meetup.title}
                />
                );
            })}
        </ul>
    );
}

export default MeetupList;
